<!-- ═══════════════ Decline referral (shared referral-dialog look) ═══════════════
     fixed header · ONE scrolling body · sticky action bar -->
<div class="ar-dialog">

  <header class="ar-head">
    <div class="ar-head-ic bad"><mat-icon>cancel</mat-icon></div>
    <div class="ar-head-txt">
      <h2>Decline referral</h2>
      <p><b>{{ personName }}</b><span class="ar-dot">·</span>{{ isExternal ? 'tell the hospital why, and notify your contacts' : 'notify your contacts' }}</p>
    </div>
    <button mat-icon-button class="ar-close" (click)="close()" matTooltip="Close"><mat-icon>close</mat-icon></button>
  </header>

  <mat-dialog-content class="ar-body">

    <!-- Current hospital-portal response (noticeable — the user is about to change it) -->
    <div class="ar-note history" *ngIf="isExternal && data.selectedRecord?.sourceResponseName">
      <mat-icon>history</mat-icon>
      <span>Previously sent <b>{{ data.selectedRecord.sourceResponseName }}</b><ng-container *ngIf="data.selectedRecord.sourceResponseBy"> by <b>{{ data.selectedRecord.sourceResponseBy }}</b></ng-container></span>
    </div>
    <!-- Internal / single-facility rows: the referral's current status, so the user knows what they are changing -->
    <div class="ar-note history" *ngIf="!data?.selectedRecord?.sourceResponseName && !providerOptions.length">
      <mat-icon>history</mat-icon>
      <span>Current status <b>{{ rowState() }}</b></span>
    </div>

    <!-- Sync OFF: declining will update Flowtrics only — say so BEFORE they confirm -->
    <div class="ar-note warn" *ngIf="isExternal && data?.portalSyncOff">
      <mat-icon>sync_disabled</mat-icon>
      <span><b>Your CarePort sync is off — this Decline will update Flowtrics only.</b>
        The referral moves to Declined here, but <b>the hospital will NOT be notified</b> and no portal decline reason is needed.
        To notify them, enable Sync in <b>My Profile → External Referral Sources</b> first.</span>
    </div>

    <!-- ── Who is this Decline for (multi-recipient portal referrals) ── -->
    <section class="ar-section" *ngIf="providerOptions.length">
      <div class="ar-sec-head">
        <mat-icon class="ar-sec-ic">fact_check</mat-icon>
        <h3>Who is this Decline for?</h3>
        <span class="ar-sec-sub">this referral went to {{ providerOptions.length }} facilities</span>
      </div>
      <div class="ar-pick">
        <label class="ar-pick-item" *ngFor="let f of providerOptions"
               [class.checked]="selectedProviderKeys[provKey(f)]"
               [class.disabled]="providerDisabled(f)"
               [class.already]="alreadyIn(f)"
               [matTooltip]="providerHint(f)">
          <input type="checkbox" [checked]="selectedProviderKeys[provKey(f)]"
                 [disabled]="providerDisabled(f)"
                 (change)="selectedProviderKeys[provKey(f)] = $any($event.target).checked" />
          <span class="ar-pick-txt">
            <span class="ar-pick-row">
              <span class="ar-pick-nm">{{ f.facilityName }}</span>
              <span class="ar-pick-mine" *ngIf="f.isMine">this office</span>
              <span class="ar-pick-already" *ngIf="alreadyIn(f)">already {{ actionLabel() }}</span>
            </span>
            <!-- current state of this facility: who · when -->
            <span class="ar-pick-st">{{ stateLine(f) || 'No response yet' }}</span>
          </span>
        </label>
      </div>
      <div class="ar-pick-warn" *ngIf="!canSubmitProviders() && !allAlready()">
        <mat-icon>error_outline</mat-icon> Select at least one facility to continue.
      </div>
      <!-- Same response again: those facilities stay unselectable and the user is told why -->
      <div class="ar-note warn" style="margin-top:10px" *ngIf="alreadyList().length && !allAlready()">
        <mat-icon>info_outline</mat-icon>
        <span><b>Already {{ actionLabel() }}:</b> {{ alreadyText() }}. These cannot be selected again — the hospital already has that answer for them.</span>
      </div>
      <div class="ar-note danger" style="margin-top:10px" *ngIf="allAlready()">
        <mat-icon>block</mat-icon>
        <span>Every facility on this referral is already <b>{{ actionLabel() }}</b> — there is nothing new to send.</span>
      </div>
    </section>

    <!-- ── Decline reason (portal declines require one) ── -->
    <section class="ar-section ar-reasons" *ngIf="isExternal && !data?.portalSyncOff">
      <div class="ar-sec-head">
        <mat-icon class="ar-sec-ic">rule</mat-icon>
        <h3>Reason for declining <span style="color:#dc2626">*</span></h3>
        <span class="ar-sec-sub">sent to the hospital with the decline</span>
      </div>
      <mat-radio-group class="ar-reason-grid" [(ngModel)]="selectedDeclineReasonId">
        <mat-radio-button *ngFor="let r of declineReasons" [value]="r.id">{{ r.name }}</mat-radio-button>
      </mat-radio-group>
      <div class="ar-reason-loading" *ngIf="!declineReasons.length">Loading decline reasons from the portal…</div>
    </section>

    <!-- ── Notification ── -->
    <section class="ar-section">
      <div class="ar-sec-head">
        <mat-icon class="ar-sec-ic">mail_outline</mat-icon>
        <h3>Notification</h3>
        <span class="ar-sec-sub">{{ isExternal ? 'message goes to the hospital; emails to the addresses you add' : 'optional — sent to the addresses you add' }}</span>
      </div>
      <div class="ar-lead bad">
        <mat-icon>unsubscribe</mat-icon>
        <span>This is to formally inform you that <b>{{ personName }}</b> has been <b>declined</b>.</span>
      </div>

      <mat-form-field appearance="outline" class="ar-field">
        <mat-label>{{ isExternal ? 'Message (sent to hospital, optional)' : 'Message' }}</mat-label>
        <textarea matInput [placeholder]="isExternal ? 'This will be sent along with the decline…' : 'Add a message to the email (optional)'"
                  rows="3" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6" [(ngModel)]="message"></textarea>
      </mat-form-field>

      <div class="ar-email-row">
        <mat-form-field appearance="outline" class="ar-field">
          <mat-label>Email</mat-label>
          <mat-icon matPrefix>alternate_email</mat-icon>
          <input matInput maxlength="200" placeholder="name@example.com" [(value)]="emailAssigned"
                 (input)="emailCheck($event.target.value)" (keydown.enter)="addEmailButtonShow && addEmail()" />
        </mat-form-field>
        <button mat-flat-button color="primary" class="ar-add" [disabled]="!addEmailButtonShow" (click)="addEmail()">
          <mat-icon>add</mat-icon> Add
        </button>
      </div>

      <ul class="ar-chips" *ngIf="addUpdateParticipantList?.length">
        <li *ngFor="let ass of addUpdateParticipantList">
          <span class="ar-chip-av">
            <img *ngIf="ass.img" [src]="ass.img" alt="">
            <ng-container *ngIf="!ass.img">{{ ass.shortName }}</ng-container>
          </span>
          <span class="ar-chip-txt"><b>{{ ass.name || ass.email }}</b><small *ngIf="ass.name">{{ ass.email }}</small></span>
          <button mat-icon-button class="ar-chip-x" matTooltip="Remove" (click)="removeParticipant(ass)"><mat-icon>close</mat-icon></button>
        </li>
      </ul>
    </section>

  </mat-dialog-content>

  <footer class="ar-actions">
    <button mat-button class="ar-cancel" (click)="close()">Cancel</button>
    <span class="ar-spacer"></span>
    <button mat-flat-button class="ar-danger" type="submit" (click)="declineAndSendMail()"
            [disabled]="!canSubmitProviders() || spinner">
      <mat-spinner *ngIf="spinner" diameter="18"></mat-spinner>
      <mat-icon *ngIf="!spinner">cancel</mat-icon>
      {{ textButton }}
    </button>
  </footer>

</div>

<app-loader></app-loader>
